// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"uilwm434Yy8gJ-0YrT0XXg==","closeIcon":"ZrOZyuzY+HBgwPQlCXXHlA==","item":"_99Vcg3SGs7385QHTz02MIA==","list":"vFtUGS9nMzsgUSDfn9a01Q=="};